/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

MobileMenuService.$inject = [
    'AnalyticsService'
];

function MobileMenuService (AnalyticsService) {
    var _pub = {},
        _htmlBody = angular.element('body'),
        _htmlMobileNav = angular.element('.mobile-nav'),
        _htmlMobileNavBackdrop = angular.element('.mobile-nav-backdrop');

    _pub.isNavOpen = false;

    _pub.openMobileNav = function () {
        _htmlBody.addClass('mobile-nav-open');
        _htmlMobileNav.addClass('mobile-nav-visible');
        _htmlMobileNavBackdrop.addClass('is-visible');
        _pub.isNavOpen = true;
    };

    _pub.closeMobileNav = function () {
        _htmlBody.removeClass('mobile-nav-open');
        _htmlMobileNav.removeClass('mobile-nav-visible');
        _htmlMobileNavBackdrop.removeClass('is-visible');
        _pub.isNavOpen = false;
    };

    _pub.trackNavEngagement = function (display, url) {
        AnalyticsService.reportEvent('Nav Engaged', {
            location: 'nav drawer',
            url: url,
            value: display,
        });
    };

    return _pub;
}

module.exports = MobileMenuService;
